import React, { Suspense } from 'react';

/**
 * Asynchronously load the summary page so that we don't load uneccessary data
 * before it's needed
 */
const AsyncSummary = React.lazy(() => import('./ModalSummary'));

const SummaryView = () => {
  return (
    <Suspense fallback={null}>
      <AsyncSummary />
    </Suspense>
  );
};

export default SummaryView;
